'use client';

import { c as _c } from "react/compiler-runtime";
import { Switch, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo } from 'react';
import { trackFilterChanged } from '@/lib/analytics/client/trackers/filter';
export interface InWalletFilterProps {
  isActive: boolean;
  isLoading?: boolean;
  hasHoldings?: boolean;
  onChange: (enabled: boolean) => void;
  tooltipContent: string;
  page?: string;
}
const InWalletFilter = t0 => {
  const $ = _c(14);
  const {
    isActive,
    isLoading: t1,
    hasHoldings: t2,
    onChange,
    tooltipContent,
    page
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const hasHoldings = t2 === undefined ? true : t2;
  const isDisabled = isLoading || !hasHoldings;
  let t3;
  if ($[0] !== isActive || $[1] !== onChange || $[2] !== page) {
    t3 = () => {
      const newValue = !isActive;
      onChange(newValue);
      if (page) {
        trackFilterChanged({
          filterName: "in_wallet",
          filterValue: newValue,
          page
        });
      }
    };
    $[0] = isActive;
    $[1] = onChange;
    $[2] = page;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClick = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-3xs text-foreground">In Wallet:</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== handleClick || $[6] !== isActive || $[7] !== isDisabled) {
    t5 = <TooltipTrigger asChild={true}><Switch checked={isActive} onCheckedChange={handleClick} disabled={isDisabled} data-testid="in-wallet-filter-switch" /></TooltipTrigger>;
    $[5] = handleClick;
    $[6] = isActive;
    $[7] = isDisabled;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== tooltipContent) {
    t6 = <TooltipContent>{tooltipContent}</TooltipContent>;
    $[9] = tooltipContent;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="gap-xs flex items-center">{t4}<Tooltip>{t5}{t6}</Tooltip></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default memo(InWalletFilter);